import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import type { Tables } from '@/integrations/supabase/types';

export const useProfile = () => {
  const { user } = useAuth();

  const { data: profile, isLoading, error } = useQuery<Tables<'profiles'> | null>({
    queryKey: ['profile', user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user!.id)
        .single();
      if (error) throw error;
      return data;
    },
  });

  const isAdmin = profile?.role === 'admin';

  return { profile, isAdmin, isLoading, error };
};
